import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { getUser } from 'store/actions/userAccess';
import Auth from 'aws-amplify';
import type { User } from 'vl-common/src/schemas/shared';

export function useRegistrationUser(refetch = 0) {
  const [user, setUser] = useState<User>();
  const { replace } = useRouter();
  const dispatch = useDispatch();
  const { query } = useRouter();

  useEffect(() => {
    async function fetchUser() {
      const cog = await Auth.currentSession();
      const token = cog.getIdToken().getJwtToken();
      const userGUID = cog.getIdToken().payload?.sub;

      if (!userGUID) throw new Error('Missing user GUID in JWT token');

      const r = await getUser(userGUID, token, dispatch, query);

      setUser(r.data);
    }

    fetchUser().catch(() => {});
  }, [dispatch, query, refetch]);

  // redirect user back to their dashboard if registration is complete
  useEffect(() => {
    if (user && !user.self_reg_required) {
      replace('/patients').then();
    }
  }, [user, replace]);

  return user;
}
